import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useConfig } from '@app/config';
import { gql, request } from 'graphql-request';
import { NFTMarketplaceBid } from '@app/types/nftMarketplace';
import { useAddress } from '@thirdweb-dev/react';

async function fetcher(
  listingId: string,
  apiUrl: string | undefined,
  address: string | undefined
) {
  if (!apiUrl || !address) {
    return null;
  }

  const res = await request<{ bids: NFTMarketplaceBid[] }>(
    `${apiUrl}`,
    gql`
      query {
        bids(where: { listing: "${listingId}", isActive: true, from: "${address.toLowerCase()}" }) {
          id
        }
      }
    `
  );

  return res.bids.length > 0;
}

export function useIsBidder(listingId: string) {
  const config = useConfig();
  const address = useAddress();

  return useQuery<boolean | null>(
    [
      QueryKeys.GET_IS_BIDDER,
      listingId,
      config?.URLS.subgraphUrlNftMarketplace,
      address
    ],
    () => fetcher(listingId, config?.URLS.subgraphUrlNftMarketplace, address),
    {
      staleTime: 5000,
      enabled: !!address && !!config?.URLS.subgraphUrlNftMarketplace
    }
  );
}
